import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppStateService } from '../../../core/services';

@Component({
  selector: 'app-locale-redirect',
  standalone: true,
  template: ''
})
export class LocaleRedirectComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly appState = inject(AppStateService);

  ngOnInit(): void {
    const locale = this.appState.locale() || 'pt_PT';
    const currentUrl = this.router.url || '/';
    const normalizedUrl = currentUrl.startsWith('/') ? currentUrl : `/${currentUrl}`;
    const targetUrl = normalizedUrl.startsWith(`/${locale}/`) || normalizedUrl === `/${locale}`
      ? normalizedUrl
      : `/${locale}${normalizedUrl}`;

    this.router.navigateByUrl(targetUrl, { replaceUrl: true });
  }
}
